import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { UserAuthGuard } from './guards/user-auth.guard';
import { RedirectToPlaystoreGuard } from './views/components/app-play-store/guards/redirect-to-playstore.guard';
import { InviteUserComponent } from './views/pages/invite-user/invite-user.component';

export const getMainAppRoute = () => {
  return 'main-app';
}

@Component({
    standalone: true,
    template: `
        <div style="
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            height:100vh;
            font-family:Arial,sans-serif;
            text-align:center;
        ">
            <h1 style="font-size:80px;margin:0;">404</h1>
            <h2>Page Not Found</h2>
            <p>Halaman yang Anda cari tidak ditemukan.</p>

            <a href="/auth/login" style="
                margin-top:20px;
                padding:10px 20px;
                background:#0d6efd;
                color:white;
                text-decoration:none;
                border-radius:6px;
            ">
                Kembali ke Halaman Login
            </a>
        </div>
    `
})
class NotFoundPage {}

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'landing',
    loadChildren: () => import('src/app/views/pages/landing/landing.module').then(m => m.LandingModule)
  },
  {
    path: 'start-page',
    loadChildren: () => import('src/app/views/pages/start-page/start-page.module').then(m => m.StartPageModule)
  },
  {
    path: 'inviteuser',
    component: InviteUserComponent,
  },
  {
    path: 'not-found',
    component: NotFoundPage
  },
  {
    path: 'auth',
    loadChildren: () => import('src/app/views/pages/login-register/login-register.module').then(m => m.LoginRegisterModule),
  },
  {
    path: getMainAppRoute(),
    loadChildren: () => import('src/app/views/pages/main-app/main-app.module').then(m => m.MainAppModule),
  },
  {
    path: 'android',
    canActivate: [RedirectToPlaystoreGuard],
    component: RedirectToPlaystoreGuard,
    data: {
      externalUrl: 'https://play.google.com/store/apps/details?id=id.ikd.screenout'
    }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
